/**
 * Legacy events forwarded by pre-cleanup rules recorded their metadata.eventType
 * as literal "unknown" and stored the real event type in data.sourceEventType.
 * This helper prefers the real type for display when available.
 *
 * Used by every UI site that renders an event type label (Events table, tree,
 * compact view, detail panel, view Events tab) so the display is consistent.
 */
export function resolveEventType(item: {
  metadata?: { eventType?: string; [k: string]: unknown };
  data?: unknown;
}): string {
  const et = item?.metadata?.eventType;
  if (et && et !== 'unknown') return et;
  const src = (item?.data as Record<string, unknown> | undefined)?.sourceEventType;
  if (typeof src === 'string' && src) return src;
  return et || '—';
}
